"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const TooltipPortal_1 = __importDefault(require("components/shared/Tooltips/TooltipPortal"));
const TooltipContainer = ({ tooltipClass = '', show, text, children, classContainer, position = 'top', align = 'middle', onClick, dataCy, customStyle, wrap = false, dataCyTooltip, useMaxWidth = true, textChangeable = false, callbackRef, tooltipContent }) => {
    const [portalData, setPortalData] = (0, react_1.useState)({});
    const [clientRect, setClientRect] = (0, react_1.useState)();
    const [isTooltipShown, setIsTooltipShown] = (0, react_1.useState)(false);
    const timeoutId = (0, react_1.useRef)(null);
    const setPortal = () => {
        if (show) {
            const rect = clientRect && clientRect?.getBoundingClientRect();
            setIsTooltipShown(true);
            const portalData = {
                name: (0, HelperUtils_1.getObjectiveLocale)(text),
                noWrap: !wrap
            };
            text && (portalData.name = (0, HelperUtils_1.getObjectiveLocale)(text));
            tooltipContent && (portalData.tooltipContent = tooltipContent());
            if (rect) {
                if (align == 'left')
                    portalData.left = rect?.left;
                if (align == 'middle') {
                    portalData.left = rect?.left + rect?.width / 2;
                    portalData.translateX = '-50%';
                }
                if (align == 'right') {
                    portalData.left = rect?.right;
                    portalData.translateX = '-100%';
                }
                if (position == 'top') {
                    portalData.top = rect?.top - 8;
                    portalData.translateY = '-100%';
                }
                if (position == 'bottom') {
                    portalData.top = rect?.bottom + 8;
                }
            }
            setPortalData(portalData);
        }
    };
    const handleRef = (ref) => {
        setClientRect(ref);
        callbackRef && callbackRef(ref);
    };
    const onMouseEnter = () => {
        timeoutId.current = setTimeout(() => {
            setPortal();
        }, 500);
    };
    const onMouseLeave = () => {
        setIsTooltipShown(false);
        timeoutId?.current && clearTimeout(timeoutId.current);
    };
    (0, react_1.useEffect)(() => {
        if (textChangeable && isTooltipShown) {
            setPortalData((data) => {
                return {
                    ...data,
                    name: 'aaa'
                };
            });
        }
    }, [text, setPortalData, isTooltipShown, textChangeable]);
    (0, react_1.useEffect)(() => {
        !show && onMouseLeave();
    }, [show]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TooltipPortal_1.default, { show: isTooltipShown, portalData: portalData, portalId: 'shared-tooltip', className: `${tooltipClass} ${useMaxWidth ? 'max-w-[240px]' : ''}`, dataCy: dataCyTooltip }),
        react_1.default.createElement("div", { className: `${classContainer ? classContainer : ''}`, ref: (ref) => ref && handleRef(ref), onMouseEnter: () => onMouseEnter(), onMouseLeave: () => onMouseLeave(), onPointerLeave: () => onMouseLeave(), "data-cy": dataCy, onClick: onClick, style: customStyle }, children)));
};
exports.default = TooltipContainer;
